import _ from 'underscore';
import type { AjaxCompositeHandler } from '../../types';

export class AjaxCompositeEventHandler {
  handlers: AjaxCompositeHandler[];
  constructor(handlers: unknown) {
    const handlerList = handlers as AjaxCompositeHandler[];
    if (!_.isArray(handlers) || handlerList.length === 0) {
      throw new Error('AjaxCompositeEventHandler expects a non-empty array of handlers');
    }
    this.handlers = handlerList;
  }

  beforeSendHandler(...args: unknown[]) {
    _.forEach(this.handlers, (handler: AjaxCompositeHandler) => _.isFunction(handler.beforeSendHandler) && handler.beforeSendHandler(...args));
  }

  successHandler(...args: unknown[]) {
    _.forEach(this.handlers.slice().reverse(), (handler: AjaxCompositeHandler) => _.isFunction(handler.successHandler) && handler.successHandler(...args));
  }

  successRenderHandler(...args: unknown[]) {
    _.forEach(this.handlers.slice().reverse(), (handler: AjaxCompositeHandler) => _.isFunction(handler.successRenderHandler) && handler.successRenderHandler(...args));
  }

  errorHandler(...args: unknown[]) {
    _.forEach(this.handlers.slice().reverse(), (handler: AjaxCompositeHandler) => _.isFunction(handler.errorHandler) && handler.errorHandler(...args));
  }

  completeHandler(...args: unknown[]) {
    _.forEach(this.handlers.slice().reverse(), (handler: AjaxCompositeHandler) => _.isFunction(handler.completeHandler) && handler.completeHandler(...args));
  }
}
